import net from '@/services/net'
export const getTelOverview = (params: any) => {
	return net('/frontApi/app/func/tel/overview', {
		method: 'post',
		params: params,
	})
}

export const getWhiteBoardOverview = (params: any) => {
	return net('/frontApi/app/func/whiteBoard/overview', {
		method: 'post',
		params: params,
	})
}
export const setWhiteBoardConfig = (params: any) => {
	return net('/frontApi/app/func/whiteBoard/config/set', {
		method: 'post',
		params: params,
	})
}
export const getWhiteBoardConfig = (params: any) => {
	return net('/frontApi/app/func/whiteBoard/config/query', {
		method: 'post',
		params: params,
	})
}
export const setWhiteBoardExperienceUnLimit = (params: any) => {
	return net('/frontApi/app/func/whiteBoard/experience/unLimitSet', {
		method: 'post',
		data: params,
	})
}
export const setWhiteBoardExperience = (params: any) => {
	return net('/frontApi/app/func/whiteBoard/experience/set', {
		method: 'post',
		data: params,
	})
}
export const funcnetcallexperienceunLimitSet = (params: any) => {
	return net('/frontApi/app/func/netcall/experience/unLimitSet', {
		method: 'post',
		data: params,
	})
}
export const funcnetcallexperienceset = (params: any) => {
	return net('/frontApi/app/func/netcall/experience/set', {
		method: 'post',
		data: params,
	})
}
export const funcimexperienceunLimitSet = (params: any) => {
	return net('/frontApi/app/func/im/experience/unLimitSet', {
		method: 'post',
		data: params,
	})
}
export const funcimexperienceset = (params: any) => {
	return net('/frontApi/app/func/im/experience/set', {
		method: 'post',
		data: params,
	})
}
export const funcnetcallqualityLevelset = (params: any) => {
	return net('/frontApi/app/func/netcall/qualityLevel/set', {
		method: 'post',
		params: params,
	})
}
export const queryVodConfig = (params: any) => {
	return net('/frontApi/app/func/vod/queryVodConfig', {
		method: 'post',
		params: params,
	})
}
export const setVodConfig = (params: any) => {
	return net('/frontApi/app/func/vod/setVodConfig', {
		method: 'post',
		params: params,
	})
}
